import axios from 'axios';

import { handleApiError, parseArrayParamsToQueryStrings } from 'utils/api';
import { camelToSnake, snakeToCamel, keysToCase } from 'utils/case';

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_CORE_API_HOST}/labeling/checks`,
  headers: {
    post: { 'Content-Type': 'application/json' },
  },
  responseEncoding: 'utf8',
  validateStatus: status => status === 200 || status === 201 || status === 204,
});

axiosInstance.interceptors.request.use(
  config => ({
    ...config,
    data: keysToCase(config.data, camelToSnake),
    params: parseArrayParamsToQueryStrings(keysToCase(config.params, camelToSnake)),
  }),
  error => error,
);

axiosInstance.interceptors.response.use(
  response => keysToCase(response.data, snakeToCamel),
  error => Promise.reject(handleApiError(error)),
);

export default axiosInstance;
